// import React from "react";

// const orders = [
//   { product: "Iphone 13 Pro", id: "#11232", date: "Jun 29, 2022", customer: "Afaq Karim", status: "Delivered", amount: "$400.00" },
//   { product: "Mackbook Pro", id: "#11233", date: "Jun 29, 2022", customer: "Afaq Karim", status: "Pending", amount: "$288.00" },
//   { product: "Apple Watch", id: "#11234", date: "Jun 29, 2022", customer: "Afaq Karim", status: "Canceled", amount: "$500.00" },
//   { product: "Microsoft Book", id: "#11235", date: "Jun 29, 2022", customer: "Afaq Karim", status: "Delivered", amount: "$100.00" },
//   { product: "Apple Pen", id: "#11236", date: "Jun 29, 2022", customer: "Afaq Karim", status: "Delivered", amount: "$60.00" },
//   { product: "Airpods", id: "#11237", date: "Jun 29, 2022", customer: "Afaq Karim", status: "Delivered", amount: "$80.00" },
// ];

// const statusClass = (s: string) => {
//   if (s === "Delivered") return "status delivered";
//   if (s === "Pending") return "status pending";
//   if (s === "Canceled") return "status canceled";
//   return "status";
// };

// const OrdersTable: React.FC = () => {
//   return (
//     <div className="card p-3 orders-card">
//       <h6 className="mb-3">Latest Orders</h6>
//       <div className="table-responsive">
//         <table className="table table-borderless mb-0">
//           <thead className="small text-muted">
//             <tr>
//               <th>Products</th>
//               <th>Order ID</th>
//               <th>Date</th>
//               <th>Customer name</th>
//               <th>Status</th>
//               <th>Amount</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {orders.map((o) => (
//               <tr key={o.id}>
//                 <td>{o.product}</td>
//                 <td>{o.id}</td>
//                 <td>{o.date}</td>
//                 <td>{o.customer}</td>
//                 <td><span className={statusClass(o.status)}></span> {o.status}</td>
//                 <td>{o.amount}</td>
//                 <td><i className="bi bi-three-dots-vertical"></i></td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default OrdersTable;



// import React, { useState, useMemo } from "react";
// import { IOrders, IShippingAddress } from "../utils/interface";
// import { useGlobalContext } from "../context/globalContext";

// interface Props {
//   orders?: IOrders[];
// }

// const OrdersTable: React.FC<Props> = ({ orders = [] }) => {
//   const { approveOrder, declineOrder } = useGlobalContext();
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 20;

//   // ✅ Sort pending first, then by most recent
//   const sortedOrders = useMemo(() => {
//     return [...orders].sort((a, b) => {
//       const aPending = a.orderStatus?.toLowerCase() === "pending";
//       const bPending = b.orderStatus?.toLowerCase() === "pending";
//       if (aPending && !bPending) return -1;
//       if (!aPending && bPending) return 1;
//       return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
//     });
//   }, [orders]);

//   // ✅ Pagination
//   const indexOfLast = currentPage * ordersPerPage;
//   const indexOfFirst = indexOfLast - ordersPerPage;
//   const currentOrders = sortedOrders.slice(indexOfFirst, indexOfLast);
//   const totalPages = Math.ceil(sortedOrders.length / ordersPerPage);

//   const goToPage = (page: number) => {
//     if (page >= 1 && page <= totalPages) setCurrentPage(page);
//   };

//   return (
//     <div className="card p-4 shadow-sm border-0 rounded-3">
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h5 className="mb-0 fw-bold text-dark">📦 Latest Orders</h5>
//         <span className="text-muted small">
//           Showing {indexOfFirst + 1} - {Math.min(indexOfLast, sortedOrders.length)} of{" "}
//           {sortedOrders.length.toLocaleString()} orders
//         </span>
//       </div>

//       <div className="table-responsive">
//         <table className="table table-striped table-hover align-middle mb-0">
//           <thead className="table-dark text-nowrap">
//             <tr>
//               <th>User</th>
//               <th>Phone</th>
//               <th>Address</th>
//               <th>Items</th>
//               <th>Total</th>
//               <th>Payment</th>
//               <th>Date</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {currentOrders.length > 0 ? (
//               currentOrders.map((o) => {
//                 const userInfo = o.username || (o.user as any)?.name || "Unknown";
//                 const phone = o.phoneNumber || (o.user as any)?.phoneNumber || "N/A";
//                 const addr =
//                   typeof o.shippingAddress === "object"
//                     ? `${(o.shippingAddress as IShippingAddress).address}, ${(o.shippingAddress as IShippingAddress).state}`
//                     : String(o.shippingAddress || "N/A");

//                 return (
//                   <tr key={o._id}>
//                     <td className="fw-semibold text-capitalize">{userInfo}</td>
//                     <td>{phone}</td>

//                     <td
//                       className="text-truncate"
//                       style={{
//                         maxWidth: "240px",
//                         cursor: "pointer",
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }}
//                       title={addr}
//                     >
//                       {addr}
//                     </td>

//                     {/* ✅ ITEMS COLUMN */}
//                     <td>
//                       <div className="position-relative">
//                         <span
//                           className="badge bg-info text-dark cursor-pointer"
//                           style={{ cursor: "pointer" }}
//                           data-bs-toggle="tooltip"
//                           data-bs-html="true"
//                           title={o.items
//                             ?.map(
//                               (i) =>
//                                 `<div><strong>${i.name || i.productName}</strong> - ₦${i.price.toLocaleString()} × ${i.quantity}</div>`
//                             )
//                             .join("") || "No items"}
//                         >
//                           {o.items?.length || 0} items
//                         </span>
//                       </div>
//                     </td>

//                     <td className="fw-bold text-success">
//                       ₦{o.totalAmount.toLocaleString()}
//                     </td>

//                     <td>{o.paymentStatus}</td>
//                     <td>{new Date(o.createdAt).toLocaleDateString()}</td>

//                     <td>
//                       <div className="dropdown">
//                         <button
//                           className="btn btn-sm btn-outline-secondary dropdown-toggle"
//                           type="button"
//                           data-bs-toggle="dropdown"
//                           aria-expanded="false"
//                         >
//                           Actions
//                         </button>
//                         <ul className="dropdown-menu dropdown-menu-end shadow-sm rounded-3">
//                           <li>
//                             <button
//                               className="dropdown-item text-success"
//                               onClick={() => approveOrder(o._id)}
//                             >
//                               <i className="bi bi-check2-circle me-2"></i>Approve
//                             </button>
//                           </li>
//                           <li>
//                             <button
//                               className="dropdown-item text-danger"
//                               onClick={() => declineOrder(o._id)}
//                             >
//                               <i className="bi bi-x-circle me-2"></i>Decline
//                             </button>
//                           </li>
//                         </ul>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })
//             ) : (
//               <tr>
//                 <td colSpan={8} className="text-center text-muted py-4">
//                   No orders yet.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* ✅ Pagination */}
//       {totalPages > 1 && (
//         <div className="d-flex justify-content-center mt-3">
//           <nav>
//             <ul className="pagination pagination-sm mb-0">
//               <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//                 <button className="page-link" onClick={() => goToPage(currentPage - 1)}>
//                   Previous
//                 </button>
//               </li>

//               {[...Array(totalPages)].map((_, i) => (
//                 <li
//                   key={i}
//                   className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
//                 >
//                   <button className="page-link" onClick={() => goToPage(i + 1)}>
//                     {i + 1}
//                   </button>
//                 </li>
//               ))}

//               <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
//                 <button className="page-link" onClick={() => goToPage(currentPage + 1)}>
//                   Next
//                 </button>
//               </li>
//             </ul>
//           </nav>
//         </div>
//       )}
//     </div>
//   );
// };

// // ✅ Initialize Bootstrap tooltips on mount
// useEffect(() => {
//   const tooltipTriggerList = Array.from(
//     document.querySelectorAll('[data-bs-toggle="tooltip"]')
//   );
//   tooltipTriggerList.forEach((el) => new (window as any).bootstrap.Tooltip(el));
// }, []);

// export default OrdersTable;







import React, { useState, useMemo, useEffect } from "react";
import { IOrders, IShippingAddress } from "../utils/interface";
import { useGlobalContext } from "../context/globalContext";

interface Props {
  orders?: IOrders[];
}

interface IOrderItem {
  name?: string;
  productName?: string;
  quantity: number;
  price: number;
}

const OrdersTable: React.FC<Props> = ({ orders = [] }) => {
  const { approveOrder, declineOrder } = useGlobalContext();
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 20;

  // ✅ Sort pending first, then newest
  const sortedOrders = useMemo(() => {
    return [...orders].sort((a, b) => {
      const aPending = a.orderStatus?.toLowerCase() === "pending";
      const bPending = b.orderStatus?.toLowerCase() === "pending";
      if (aPending && !bPending) return -1;
      if (!aPending && bPending) return 1;
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
  }, [orders]);

  // ✅ Pagination
  const indexOfLast = currentPage * ordersPerPage;
  const indexOfFirst = indexOfLast - ordersPerPage;
  const currentOrders = sortedOrders.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(sortedOrders.length / ordersPerPage);

  const goToPage = (page: number) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // ✅ Initialize clean Bootstrap tooltips (supports multiline)
  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((el) => {
      try {
        new (window as any).bootstrap.Tooltip(el, {
          customClass: "multiline-tooltip",
        });
      } catch (err) {
        console.warn("Tooltip init error:", err);
      }
    });
  }, [currentOrders]);

  // ✅ Tooltip styling
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .tooltip-inner {
        white-space: pre-line !important;
        text-align: left !important;
        font-size: 13px;
      }
    `;
    document.head.appendChild(style);
  }, []);

  const statusClass = (status: string) => {
    switch (status?.toLowerCase()) {
      case "approved":
      case "delivered":
        return "badge bg-success";
      case "pending":
        return "badge bg-warning text-dark";
      case "declined":
      case "canceled":
        return "badge bg-danger";
      default:
        return "badge bg-secondary";
    }
  };

  return (
    <div className="card p-4 shadow-sm border-0 rounded-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 fw-bold text-dark">📦 Latest Orders</h5>
        <span className="text-muted small">
          Showing {indexOfFirst + 1} - {Math.min(indexOfLast, sortedOrders.length)} of{" "}
          {sortedOrders.length.toLocaleString()} orders
        </span>
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-hover align-middle mb-0">
          <thead className="table-dark text-nowrap">
            <tr>
              <th>#</th>
              <th>User</th>
              <th>Phone</th>
              <th>Address</th>
              <th>Items</th>
              <th>Total</th>
              <th>Status</th>
              <th>Payment</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {currentOrders.length > 0 ? (
              currentOrders.map((o, idx) => {
                const userInfo = o.username || (o.user as any)?.name || "Unknown";
                const phone =
                  o.phoneNumber || (o.user as any)?.phoneNumber || "N/A";
                const addr =
                  typeof o.shippingAddress === "object"
                    ? `${(o.shippingAddress as IShippingAddress).address}, ${(o.shippingAddress as IShippingAddress).state}`
                    : String(o.shippingAddress || "N/A");

                const items = (o as any).items as IOrderItem[] | undefined;

                const itemTooltip =
                  items && items.length > 0
                    ? items
                        .map(
                          (i, n) =>
                            `${n + 1}. ${i.name || i.productName || "Unnamed"} — ₦${i.price?.toLocaleString()} × ${i.quantity}`
                        )
                        .join("\n")
                    : "No items";

                return (
                  <tr key={o._id}>
                    <td>{indexOfFirst + idx + 1}</td>
                    <td className="fw-semibold text-capitalize">{userInfo}</td>
                    <td>{phone}</td>
                    <td
                      className="text-truncate"
                      style={{
                        maxWidth: "220px",
                        cursor: "pointer",
                      }}
                      title={addr}
                    >
                      {addr}
                    </td>

                    {/* ✅ CLEAN COLUMN TOOLTIP */}
                    <td>
                      <span
                        className="badge bg-info text-dark"
                        style={{ cursor: "pointer" }}
                        data-bs-toggle="tooltip"
                        data-bs-html="false"
                        title={itemTooltip}
                      >
                        {items?.length || 0} items
                      </span>
                    </td>

                    <td className="fw-bold text-success">
                      ₦{o.totalAmount.toLocaleString()}
                    </td>
                    <td>
                      <span className={statusClass(o.orderStatus)}>
                        {o.orderStatus}
                      </span>
                    </td>
                    <td>{o.paymentStatus}</td>
                    <td>{new Date(o.createdAt).toLocaleDateString()}</td>

                    <td>
                      <div className="dropdown">
                        <button
                          className="btn btn-sm btn-outline-secondary dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Actions
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end shadow-sm rounded-3">
                          <li>
                            <button
                              className="dropdown-item text-success"
                              onClick={() => approveOrder(o._id)}
                            >
                              <i className="bi bi-check2-circle me-2"></i>Approve
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item text-danger"
                              onClick={() => declineOrder(o._id)}
                            >
                              <i className="bi bi-x-circle me-2"></i>Decline
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={10} className="text-center text-muted py-4">
                  No orders yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ✅ Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-3">
          <nav>
            <ul className="pagination pagination-sm mb-0">
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => goToPage(currentPage - 1)}>
                  Previous
                </button>
              </li>

              {[...Array(totalPages)].map((_, i) => (
                <li
                  key={i}
                  className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                >
                  <button className="page-link" onClick={() => goToPage(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}

              <li
                className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
              >
                <button className="page-link" onClick={() => goToPage(currentPage + 1)}>
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </div>
  );
};

export default OrdersTable;
